import React from "react";
import boy from "../../assets/images/home/home_blog.jpg";
import phone from "../../assets/images/home/phone image.jpg";
import LoginDialog from "../Addons/LoginModalBox";

const HomeBottom = () => {
    const [openDialog, setOpenDialog] = React.useState(false);

  return (
    <div className="bg-[#fdf9ed] w-full md:block hidden pt-6">
      {/* Main Row */}
      <div className="flex flex-col xl:flex-row gap-6">
        {/* ---------- Column 1 (Text Section) ---------- */}
        <div
          className="bg-[#d9eada] xl:w-[55%] w-full flex justify-start items-center lg:px-8 sm:px-6 px-3 py-16 xl:py-0"
          data-aos="fade-up"
        >
          <div className="flex flex-col gap-8 md:pl-20 xl:pl-14 2xl:pl-28 3xl:pl-[12.5rem]">
            <p
              className=" text-[40px] md:text-[50px]  xl:text-[60px] leading-[48px] xl:leading-[4rem] font-extralight font-lexend uppercase text-[#3b6840]"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              your perfect <br /> mondew, <br /> in 60 seconds
            </p>

            <p
              className="text-[20px] font-light font-lexend text-[#3f3f3f] w-full md:w-[60%]"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Mixed sleeper? Family bed? Posture concerns? Set aside the
              guesswork. Help us recommend the mattress that works best for you.
            </p>
            <button
              className="relative px-6 py-4 xl:text-[22px] md:w-72 sm:text-xl font-normal font-lexend shadow tracking-wider   bg-transparent isolation-auto z-10 border-2 border-[#3b6840] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-white before:-left-full before:hover:left-0 before:rounded-full before:bg-[#3b6840] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#3b6840]  gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal hover:text-[22px]"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              TAKE THE QUIZ
            </button>
          </div>
        </div>

        {/* ---------- Column 2 (Two Rows) ---------- */}
        <div className="xl:w-[45%] w-full flex flex-col gap-6">
          {/* ---- Row 1: Blog ---- */}
          <div
            className="bg-[#d9eada] text-[#3f3f3f] h-48 md:h-[300px] flex items-center ps-8 md:ps-32 xl:ps-20 3xl:ps-24"
            style={{
              backgroundImage: `url(${boy})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div>
              <p
                className="text-[20px] font-light font-lexend"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                Night-time routines <br />
                for the best sleep <br />
              </p>

              <button
                className="relative  px-6 py-3 mt-4 w-52 xl:text-[22px] sm:text-xl font-normal font-lexend shadow tracking-wider   bg-transparent isolation-auto z-10 border-2 border-[#3b6840] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-white before:-left-full before:hover:left-0 before:rounded-full before:bg-[#3b6840] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#3b6840]  gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal hover:text-[22px]"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                BLOG
              </button>
            </div>
          </div>

          {/* ---- Row 2: Newsletter ---- */}
          <div className="grid md:grid-cols-2  grid-cols-1 bg-[#d9eada] items-center pt-5 xl:py-0">
            {/* Text always left */}
            <div className=" ps-8  md:ps-32 xl:ps-20 order-1">
              <p
                className="text-[20px] font-light font-lexend text-[#3f3f3f] "
                data-aos="fade-up"
                data-aos-delay="100"
              >
                Want to transform <br /> your sleep experience? <br /> Sign up
                for "Rethink Sleep", <br /> our monthly newsletter.
              </p>
              <button   onClick={() => {
                    setOpenDialog(true);
                  }}
                className="relative px-6 py-3 mt-4 w-56 xl:text-[22px] sm:text-xl font-normal font-lexend shadow tracking-wider   bg-transparent isolation-auto z-10 border-2 border-[#3b6840] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-white before:-left-full before:hover:left-0 before:rounded-full before:bg-[#3b6840] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#3b6840]  gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal hover:text-[22px]"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                SIGN UP
              </button>
            </div>

            {/* Image always right */}
            <div className="order-2 flex justify-end mr-10">
              <img src={phone} alt="Phone" />
            </div>
          </div>
        </div>
      </div>
            <LoginDialog open={openDialog} handleClose={() => setOpenDialog(false)} />

    </div>
  );
};

export default HomeBottom;
